import { render, staticRenderFns } from "./DocumentReader.vue?vue&type=template&id=6ce96736&scoped=true"
import script from "./DocumentReader.vue?vue&type=script&lang=js"
export * from "./DocumentReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce96736",
  null
  
)

export default component.exports